import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import FuiHomePage from "./FuiHomePage";
import PlatformList from "./PlatformDetailLists/PlatformList";
import LicenseList from "./LicenseDetailLists/LicenseList";
import * as fuiRedux from "../../redux/fui/index";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useFUIMakeStyles } from "./FuiMakeStyles";
import OrderPage from "./AgentMesh/OrderPage"
//import { Footer } from "../common/Footer";

/**
 * Fulfilment home page and apps
 * @author Xiao Luo
 * @version 1.0
 * @see Used in component: routes
 */
const FulfillmentUI = ({ match, history, userDetails }) => {
  const isStandardOrder = match.params.type === "order";
  const isAgentMeshOrder = match.params.type === "agentmesh";
  const isPlatforms = match.params.type === "platforms";
  const isLicenses = match.params.type === "licenses";
  const classes = useFUIMakeStyles();

  // Check if user is from China and trying to access the order page
  const shouldRedirectChinaUser = isStandardOrder &&
    userDetails &&
    userDetails.hasOwnProperty('custom:country') &&
    userDetails['custom:country'] === 'China';

  useEffect(() => {
    if (shouldRedirectChinaUser) {
      history.push('/');
    }
  }, [shouldRedirectChinaUser, history]);

  // Don't render anything if redirecting China user
  if (shouldRedirectChinaUser) {
    return null;
  }

  return (
    <Fragment>
      {(isStandardOrder && <FuiHomePage classes={classes} />) ||
        (isAgentMeshOrder && <OrderPage classes={classes} />) ||
        (isPlatforms && (
            <PlatformList isNotProducts={true} classes={classes} routeName={"platforms"}/>
        )) ||
        (isLicenses && <LicenseList isNotProducts={true} classes={classes} />)}
      {/* <Footer /> */}
    </Fragment>
  );
};
FulfillmentUI.propTypes = {
  /**
   * History property of route library
   */
  history: PropTypes.object,
  /**
   * Match property of route library
   */
  match: PropTypes.object,
  /**
   *
   */
  clearLocalComponentData: PropTypes.func,
  /**
   * Start loading component
   */
  startLoading: PropTypes.func,
};
const mapStateToProps = state => {
  return {
    userDetails: state.auth.userDetails
  };
};

export default connect(mapStateToProps, {
  clearLocalComponentData: fuiRedux.clearLocalComponentData,
  startLoading: fuiRedux.startLoading,
})(withRouter(FulfillmentUI));
